export enum ELabels {
  INCLUDE_NUMBERS = 'Include Numbers',
  INCLUDE_UPPERCASE = 'Include Uppercase',
  INCLUDE_LOWERCASE = 'Include Lowercase',
  INCLUDE_SIMBOLS = 'Include Simbols',
  INCLUDE_SPECIAL_CHARS = 'Include Special Characters',

  CHARS_LIMIT = 'Chars. limit:'
}
